import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WileyFooterComponentComponent } from './wiley-footer-component/wiley-footer-component.component';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule
  ],
  declarations: [
    WileyFooterComponentComponent
  ],
  exports: [WileyFooterComponentComponent]
})
export class FooterModule { }
